import { render } from "./PurpleBg.vue?vue&type=template&id=0c4f2f42&scoped=true"
import script from "./PurpleBg.vue?vue&type=script&lang=js"
export * from "./PurpleBg.vue?vue&type=script&lang=js"

import "./PurpleBg.vue?vue&type=style&index=0&id=0c4f2f42&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4f2f42"]])

export default __exports__